import { urlReplace } from 'shared/modules';

export const IS_MOBILE = __APP__ === 'mobile';

export const numberWithSpaces = number => {
  const [intPart] = `${number}`.split('.');
  return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const getTitleOrEmpty = object => (object && object.title) || '';

export const getFondyCheckoutUrl = (data, p24 = false, receipt = false) => {
  let redirectUrl = data.checkout_url;
  if (p24) {
    redirectUrl = `${redirectUrl}&autoredirect=p24`;
  }
  if (receipt) {
    redirectUrl = `${redirectUrl}&autoinit=receipt`;
  }
  return redirectUrl;
};

export const postWithRedirect = (url, data = {}) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;

  Object.entries(data).forEach(([key, value]) => {
    const input = document.createElement('input');

    input.type = 'hidden';
    input.name = key;
    input.value = value;

    form.appendChild(input);
  });

  form.style.display = 'none';
  document.body.appendChild(form);
  form.submit();
};

export const getDisplayName = WrappedComponent => {
  if (!WrappedComponent) {
    return 'no_component_provided';
  }

  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

export const objectsToIDs = state => {
  const newState = {};

  Object.entries(state).forEach(([key, value]) => {
    if (value != null) {
      if (typeof value === 'object' && !Array.isArray(value)) {
        if (value.id || value.id === 0) {
          newState[key] = value.id;
        }
      } else {
        newState[key] = value;
      }
    }
  });

  return newState;
};

export const chainPromises = promises =>
  promises.reduce((prev, cur) => prev.then(cur), Promise.resolve());

export const disableReactIntlLocaleErrors = console => {
  if (!__DEV__) {
    const error = console.error;

    // eslint-disable-next-line no-param-reassign
    console.error = (...args) => {
      if (
        !(
          `${args}`.includes('for locale: "ru"') ||
          `${args.includes('using message id as fallback')}`
        )
      ) {
        error(...args);
      }
    };
  }
};

/* Discouraged */

export const getResultFromStoreByKey = (store, key) =>
  store.getState().searchForm && store.getState().searchForm.results
    ? store.getState().searchForm.results[key]
    : null;

export const imageBgStyle = (img, fill = 'cover') => ({
  background: `url(${urlReplace(img && img.replace('http:', 'https:'))}) no-repeat 50%/${fill}`,
});

export const parseEvent = e => parseInt(e.target.value, 10);

export const setDataToDebug = (url, data, toDebugJson) => {
  if (String(url).includes('opel/zafira-2/gruziya/')) {
    return { ...toDebugJson, ...data };
  }
  return null;
};

export const doRedirectToCheckout = url => {
  if (
    typeof window.customOpenWindow === 'undefined' ||
    !window.customOpenWindow ||
    window.customOpenWindow.closed ||
    typeof window.customOpenWindow.closed === 'undefined'
  ) {
    // if pop-up is blocked
    return window.location.replace(url);
  }
  window.customOpenWindow.location = url;
  return window.customOpenWindow.location;
};

export const iniRedirectToCheckout = () => {
  window.customOpenWindow = window.open('', '_blank');
};

export const adjustLinksTitle = (canonicalLinks, prefix, postfix = '') => {
  let canonicalListData = [];
  if (canonicalLinks && canonicalLinks.length) {
    if (canonicalLinks[0].title.indexOf(prefix) === -1) {
      canonicalListData = canonicalLinks.map(item => ({
        ...item,
        title: `${prefix} ${item.title} ${postfix}`.trim(),
      }));
    } else {
      canonicalListData = [...canonicalLinks];
    }
  }
  return canonicalListData;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/common.js